////////////////////////////////////////////////////////////////////////////////
// Where We Opertate
////////////////////////////////////////////////////////////////////////////////

// SCENARIOS

// Arrive on WWO - never loaded, make first load and display all markers
// Arrive on WWO Entry - never loaded, make first load and only country

// Arrive on WWO - has been loaded, move to map center
// Arrive on WWO Entry - has been loaded, move to country

let whereWeOperate = false;

class WhereWeOperate extends Pages {

	// ===========================================================================
	// Constructor
	// ===========================================================================

	constructor(entry) {

		super(entry);

		if(whereWeOperate){
      return whereWeOperate;
    }

		whereWeOperate = this;

		this.ready = false;
		this.map = false;
		this.polygonSeries = false;
		this.countryData = $('#chartdiv').data('markers');

		if ($('#chartdiv').is(':empty')){
			this.buildMap();
		}

	}

	// ===========================================================================
	// Initialisation
	// ===========================================================================

	init() {
		// No required...
		console.log('Where We Operate Init');

	}

	// ===========================================================================
	// Load In
	// ===========================================================================

	/**
	 * This is run when navigating to a country page
	 * @param  {Object}   content jQueryified object with mark up blocks.
	 * @param  {Function} done    The callback to tell the historyAPI that the page has finished loading
	 */

	in(content, done) {

		console.log(`Zoom map out to show full map`);

		document.body.classList.remove('landing');

		if ( !mobile ) {
			this.zoomToFullMap();
		}

		// Replace this for a special transition in for this country page
		page.in(content, done);

	}

	// ===========================================================================
	// Load Out
	// ===========================================================================

	/**
	 * This is run when navigating awat from a country page
	 * @param  {Object}   content jQueryified object with mark up blocks.
	 * @param  {Function} done    The callback to tell the historyAPI that the page has finished loading
	 */

	out(content, done) {

		// Replace this for a special transition out for this country page
    page.out(content, done);

	}


	// ===========================================================================
	// Zoom to full map
	// ===========================================================================

	/**
	 * Zoom out to show full map
	 * @param  {}   null   no params
	 */

	zoomToFullMap(){

		// Clear all selected countries
		this.polygonSeries.mapPolygons.each(polygon => {
			polygon.isActive = false;
		});

		this.map.goHome();

	}


	// ===========================================================================
	// Zoom to Country
	// ===========================================================================

	/**
	 * Zoom directly to an individual country
	 * @param  {Object}   entry  entry data for the selected country
	 */

	zoomToCountry(entry){

		if (!mobile) {

			this.map.closeAllPopups();

			if(this.ready){

				this.goToCountry(entry);

			} else {

				this.map.events.on('ready', ev => {
					this.ready = true;
					this.goToCountry(entry);
				});

			}
		}

	}

	// ===========================================================================
	// Go to country -> extends zoomToCountry
	// ===========================================================================

	/**
	 * Get the required data for the country from the selected entry
	 * @param  {Object}   entry  entry data for the selected country
	 */

	goToCountry(entry){

		console.log("CALLING => GO TO COUNTRY");

		let country = this.getCountryDataFromEntry(entry);
		let selectedCountry = this.polygonSeries.getPolygonById(country.countryCode);
		selectedCountry.isActive = true;
		this.map.maxZoomLevel = entry.slug == "morocco" ? 10 : 32;
		this.map.zoomToMapObject(selectedCountry);
		this.map.maxZoomLevel = 1;

	}

	// ===========================================================================
	// Get Country data from Entry
	// ===========================================================================

	/**
	 * Get the required data for the country from the selected entry
	 * @param  {Object}   entry  entry data for the selected country
	 */

	getCountryDataFromEntry(entry){

		let ret = [];
		ret = this.countryData.filter(country => country.id == entry.id);
		if(ret.length > 0){
			ret = ret[0];
		}

		return ret;

	}

	// ===========================================================================
	// Build Map
	// ===========================================================================

	/**
	 * Build the map instance ready for interaction
	 * @param  {}   null  no params
	 */

	buildMap(){

		am4core.useTheme(am4themes_animated);
		this.map = am4core.create("chartdiv", am4maps.MapChart);

		this.map.geodata = am4geodata_worldHigh;
		this.map.projection = new am4maps.projections.Miller();
		this.map.homeZoomLevel = 1;
		this.map.maxZoomLevel = 1;

		// Detect where center should be and set as homeGeoPoint / NOT CURRENTLY REQUIRED
		// this.map.homeGeoPoint = this.centralLocation();

		// - - - - - - - - - -

		/* Create map polygon series */
		this.polygonSeries = this.map.series.push(new am4maps.MapPolygonSeries());

		/* Make map load polygon (like country names) data from GeoJSON */
		this.polygonSeries.useGeodata = true;

		/* Configure series */
		let polygonTemplate = this.polygonSeries.mapPolygons.template;
		polygonTemplate.applyOnClones = true;
		polygonTemplate.togglable = false;
		//polygonTemplate.tooltipText = "{name}";
		polygonTemplate.strokeWidth = 0;
		polygonTemplate.strokeOpacity = 0;
		polygonTemplate.fill = am4core.color('#133873');

		/* Create selected and hover states and set alternative fill color */
		let ss = polygonTemplate.states.create("active");
		ss.properties.fill = am4core.color("#FFF");

		// Hide Antarctica
		this.polygonSeries.exclude = ["AQ"];

		// - - - - - - - -

		// Dot series - Used to show exact marker on map
		let dotSeries = this.map.series.push(new am4maps.MapImageSeries());
		dotSeries.id = "dots";
		let dotTemplate = dotSeries.mapImages.template;
		dotTemplate.propertyFields.longitude = "longitude";
		dotTemplate.propertyFields.latitude = "latitude";
		dotTemplate.nonScaling = true;

		let dot = dotTemplate.createChild(am4core.Rectangle);
		dot.fill = am4core.color('#FFFFFF');
		dot.fillOpacity = 0.7;
		dot.height = 5;
		dot.width = 5;

		// Image series - Wrapper for marker content
		let imageSeries = this.map.series.push(new am4maps.MapImageSeries());
		imageSeries.id = "markers";
		let imageTemplate = imageSeries.mapImages.template;
		imageTemplate.propertyFields.longitude = "longitude";
		imageTemplate.propertyFields.latitude = "latitude";
		imageTemplate.nonScaling = true;

		// Marker outline - - -
		let box = imageTemplate.createChild(am4core.Rectangle);
		box.fill = am4core.color('#FFFFFF');
		box.stroke = am4core.color('#FFFFFF');
		box.strokeOpacity = 0.5;
		box.fillOpacity = 0;
		box.height = 28;

		// box.propertyFields.width = "containerWidth";
		box.width = 80;

		box.propertyFields.horizontalCenter = "horizontalCenter";
		box.propertyFields.verticalCenter = "verticalCenter";

		box.dx = 2;
		box.dy = 2;


		// Flag Image - - -
		let image = imageTemplate.createChild(am4core.Image);
		image.propertyFields.href = "imageURL";

		image.width = 40;
		image.height = 20;

		image.propertyFields.horizontalCenter = "horizontalCenter";
		image.propertyFields.verticalCenter = "verticalCenter";

		image.propertyFields.dx = "horizontalOffsetImage";
		image.propertyFields.dy = "verticalOffsetImage";

		// Label Text - - -
		let label = imageTemplate.createChild(am4core.Label);
		// label.text = "{label}";
		label.text = "{countryCode}";
		label.fontSize = "12px";

		label.propertyFields.horizontalCenter = "horizontalCenter";
		label.propertyFields.verticalCenter = "verticalCenter";

		label.propertyFields.paddingLeft = 'paddingLeft';
		label.propertyFields.paddingRight = 'paddingRight';

		label.propertyFields.dy = "verticalOffsetLabel";

		label.fill = am4core.color('#FFFFFF');

		// this.countryData.forEach(data => {
		// 	if ( data.latitude == 0 ) {
		// 		console.warn(data.label, 'latitude: ' + data.latitude, 'longitude: ' + data.longitude);
		// 	} else {
		// 		console.log(data.label, 'latitude: ' + data.latitude, 'longitude: ' + data.longitude);
		// 	}
		// })


		// Set marker data on each series to set position of markers
		imageSeries.data = this.countryData;
		dotSeries.data = this.countryData;

		// Marker click event
		imageTemplate.events.on("hit", (ev) => {

			this.map.closeAllPopups();

			const data = ev.target.dataItem.dataContext;

			const popupContent = 	`<popup-container>
										<popup-header>
											<h3>${data.label}</h3>
										</popup-header>
										<popup-content>
											${data.introduction.replace(/\n/g, '<br>')}
											${data.address.replace(/\n/g, '<br>')}
											<a class="button" href="${data.uri}">Read more</a>
										</popup-content>
									</popup-container>`;

			const popup = this.map.openPopup(popupContent);

			// https://www.amcharts.com/docs/v4/concepts/popups-and-modals/#Accessing_Popup_Modal_elements
			// TODO: This doesn't work and the SVG element is uneditable.
			const closeBtn = document.createElement('a')
			closeBtn.innerHTML = '<svg class="icon-close" role="img" data-icon="close"><use xlink:href="#icon-close"></use></svg>'
			popup.elements.close = closeBtn;

		  popup.left = ev.svgPoint.x + 15;
		  popup.top = ev.svgPoint.y + 15;

		});

		this.map.events.on('ready', ev => {
			this.ready = true;
		});

		this.map.events.on('zoomlevelchanged', ev => {
			this.toggleFlags(ev);
		});

	}

	// ===========================================================================
	// Hide Flags when Zoomed in
	// ===========================================================================

	/**
	 * Hide the flags
	 * @param  {}   null
	 */

	toggleFlags(ev){

		let zoomThreshold = 6;
  	let flags = this.map.map.getKey("markers");
		let dots = this.map.map.getKey("dots");

		flags.mapImages.each(image => {
      this.map.zoomLevel > zoomThreshold ? image.hide() : image.show();
	  });

		dots.mapImages.each(dot => {
			this.map.zoomLevel > zoomThreshold ? dot.hide() : dot.show();
	  });
	}


	// ===========================================================================
	// Central Location - NOT CURRENTLY REQUIRED
	// ===========================================================================

	/**
	 * Calculate the center of the map based on the marker data available.
	 * @param  {}   null  no params
	 */

	// centralLocation(){
	//
	// 	const latOffset = -50;
	// 	const lngOffset = 50;
	//
	// 	let lat = 0;
	// 	let lng = 0;
	//
	// 	this.countryData.forEach((country, index) => {
	// 		lat = lat + country.latitude;
	// 		lng = lng + country.longitude;
	// 	});
	//
	// 	return {
	// 		latitude: (lat / this.countryData.length) + latOffset,
	// 		longitude: (lng / this.countryData.length) + lngOffset
	// 	};
	//
	// }

}
